/**
 * @file Assets helper.
 */

import getConfig from './config';

/**
 * Return an asset's target url.
 *
 * @param {String} path Relative asset path, example: '/favicon.ico'.
 */
const getAsset = path => {
  const config = getConfig();

  if (!config) {
    return '';
  }

  return `${config.staticDir}${path}`;
};

export { getAsset };
